__turbopack_context__.v({
  "activity": "SvgKFG_activity",
  "activity-enter": "SvgKFG_activity-enter",
  "activity-pulse": "SvgKFG_activity-pulse",
  "enter": "SvgKFG_enter",
  "headerSlot": "SvgKFG_headerSlot",
  "headerSurface": "SvgKFG_headerSurface",
  "list": "SvgKFG_list",
  "row": "SvgKFG_row",
  "rowDisclosure": "SvgKFG_rowDisclosure",
  "running": "SvgKFG_running",
  "stretch": "SvgKFG_stretch",
});
